import { create } from "zustand";

type CoverType = {
    category: string | null;
    fabricIds: Array<string>;
    leatherIds: Array<string>;
    setCategory: (category: string | null) => void;
    setFabricIds: (ids: Array<string>) => void;
    setLeatherIds: (ids: Array<string>) => void;
};

export const useCover = create<CoverType>()((set) => ({
    category: null,
    fabricIds: [],
    leatherIds: [],
    setCategory: (category: string | null) =>
        set(() => {
            return { category: category };
        }),
    setFabricIds: (ids) =>
        set(() => {
            return { fabricIds: ids };
        }),
    setLeatherIds: (ids) =>
        set(() => {
            return { leatherIds: ids };
        }),
}));
